export default __webpack_public_path__ + "static/media/logo-white.94bf5712.png";